<template>
  <div>
    <router-link
      :to="{ name: 'PersonProfilePage', params: { personId: athlete.id } }"
      :class="[classList, 'no-default-link-style']"
      >{{ displayName }}</router-link
    >
    <slot name="personNameAdditionalDetails" v-bind="{ person: athlete }" />
    <div v-if="!nameOnly" class="muted--text">{{ clubOrCountry }}</div>
    <div v-if="$scopedSlots.personAdditionalDetails">
      <slot name="personAdditionalDetails" v-bind="{ person: athlete }" />
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import { getFederationConfiguration } from "@composables/masterdata/config";
import { get } from "lodash-es";
export default {
  name: "AppShowAthleteName",
  props: {
    athlete: {
      type: Object,
      required: true
    },
    nameOnly: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String,
      default: ""
    },
    fallbackClub: {
      type: Object,
      default: null
    }
  },
  setup() {
    return {
      ...getFederationConfiguration()
    };
  },
  computed: {
    displayName() {
      return this.showDisplayName(this.athlete);
    },
    clubOrCountry() {
      if (this.athlete.clubName) {
        return this.athlete.clubName;
      } else if (this.fallbackClub) {
        return this.fallbackClub.shortName ?? this.fallbackClub.name;
      } else if (this.athlete.country) {
        return get(this.athlete, "country.name");
      } else {
        return null;
      }
    }
  },
  fragments: {
    fallbackClub: gql`
      fragment _ on Organisation {
        id
        name
        shortName
      }
    `,
    athlete: gql`
      fragment _ on Person {
        id
        name
        firstName
        lastName
        clubName
        countryId
        country @client {
          id
          name
          ioc
          alpha2
        }
      }
    `
  }
};
</script>
